<template>
  <div class="share_index_warp">
  <div v-if="formData.identityType==1">
    <div class="share_index_text">
      <div class="image" >
        <img :src="formData.shareUserInfo && formData.shareUserInfo.avatarUrl"/>
      </div>
      <div  v-if="formData.joinStatus==1">{{formData.assistCouponActivityStyle.sharePersonStyle.inviteNotice || '邀请'+formData.taskCount+'位好友领劵即可获得' }}</div>
      <div  v-if="formData.joinStatus==3">{{formData.assistCouponActivityStyle.sharePersonStyle.winAwardNotice }}</div>
      <div  v-if="formData.joinStatus==2 && formData.restCount==0">{{formData.assistCouponActivityStyle.sharePersonStyle.winAwardNotice}}</div>
      <div  v-if="formData.joinStatus==2 && formData.restCount!=0">{{formData.assistCouponActivityStyle.sharePersonStyle.inviteNotice ||'邀请'+formData.taskCount+'位好友领劵即可获得'}}</div>
    </div>
    <div class="share_index_image">
      <img :src="formData.assistCouponActivityStyle.sharePersonStyle.beforeReceiveCouponImageUrl" />
    </div>
    <div class="share_index_button">
      <van-button data-jumpType="sharePersonStyle" @click="jumpToAddress('sharePersonStyle')" v-if="formData.joinStatus==3 && formData.restCount==0" :style="styleObject(formData.assistCouponActivityStyle.sharePersonStyle.afterReceiveBtnImageUrl)"></van-button>
      <van-button  @click="receiveCoupons" v-if="formData.joinStatus==2 && formData.restCount==0" :style="styleObject(formData.assistCouponActivityStyle.sharePersonStyle.beforeReceiveBtnImageUrl)"></van-button>
    </div>
    <div class="share_index_info" v-if="formData.restCount==0">
      <div>{{formData.assistCouponActivityStyle.sharePersonStyle.assistAward}}</div>
    </div>
    <div class="share_index_content">
      <div class="share_index_content_image">
        <img :src="formData.shareUserInfo && formData.shareUserInfo.avatarUrl" />
        <span>分享人</span>
      </div>
      <div class="share_index_content_image" v-for="(item,index) in images" :key="index">
        <img :src="item.avatarUrl || addIcon" mode="widthFix" />
        <span>{{item.nickName?item.nickName:'待邀请'}}</span>
      </div>
    </div>
    <view class="cleartext" v-if="formData.restCount!=0">{{formData.assistCouponActivityStyle.sharePersonStyle.winAwardNotice || '您的好友已完成'+formData.assistUserInfo.length+'位好友领券助力'}}</view>
    <div class="share_index_footer">
      <div class="share_index_btn">
        <van-button v-if="formData.joinStatus==2 && formData.activityStatus==1 && formData.restCount!=0" class="btn" @click="getshareInfo"  :style="styleObject(formData.assistCouponActivityStyle.sharePersonStyle.inviteFriendBtnImageUrl)" >
          {{formData.assistCouponActivityStyle.sharePersonStyle.inviteFriendBtnImageUrl?'':'去邀请好友'}}
        </van-button>
        <van-button v-if="formData.joinStatus==1 && formData.activityStatus==1" class="btn" @click="involvementActicity(1)" :style="styleObject(formData.assistCouponActivityStyle.sharePersonStyle.inviteFriendBtnImageUrl)">
          {{formData.assistCouponActivityStyle.sharePersonStyle.inviteFriendBtnImageUrl?'':'去邀请好友'}}
        </van-button>
      </div>
    </div>
    <div class="share_coupon_flex" v-show="showStatus">
      <div class="image_flex">
        <img @click="involvementActicity(2)" :src="formData.assistCouponActivityStyle.sharePersonStyle.joinBtnImageUrl"  mode="widthFix"/>
        <img class="close" src="@/assets/atlas/shan.png" mode="widthFix" @click="showModalFun" />
      </div>
    </div>
  </div>
  <div v-else>
    <div class="share_index_text">
      <div class="image" >
        <img :src="formData.shareUserInfo && formData.shareUserInfo.avatarUrl"/>
      </div>
      <div>{{formData.assistCouponActivityStyle.assistPersonStyle.assistAwardNotice}}</div>
    </div>
    <div class="share_index_image">
      <img :src="formData.assistCouponActivityStyle.assistPersonStyle.couponImageUrl" mode="widthFix"/>
    </div>
    <div class="share_index_button">
      <van-button v-if="formData.joinStatus==1" catchtap="helpPersonFun" :style="{backgroundImage:'url('+formData.assistCouponActivityStyle.assistPersonStyle.seekHelpImageUrl+')'}"></van-button>
      <img  @click="jumpToAddress('assistPersonStyle')" v-if="formData.joinStatus==3" :src="formData.assistCouponActivityStyle.assistPersonStyle.afterAssistJumpImageUrl" mode="widthFix"/>
    </div>
    <div class="share_index_info">
      <div>{{formData.assistCouponActivityStyle.assistPersonStyle.assistProgressNotice}}</div>
    </div>
    <div class="share_index_content">
      <div class="share_index_content_image">
        <img :src="formData.shareUserInfo && formData.shareUserInfo.avatarUrl" />
        <span>分享人</span>
      </div>
      <div class="share_index_content_image" v-for="(item,index) in images" :key="index">
        <img :src="item.avatarUrl || addIcon" mode="widthFix"/>
        <span>{{item.nickName?item.nickName:'待邀请'}}</span>
      </div>
    </div>
    <div class="share_index_footer">
      <div class="share_index_btn">
        <van-button  v-if="formData.joinStatus==3" class="btn" :style="'backgroundImage:url('+formData.assistCouponActivityStyle.assistPersonStyle.joinBtnImageUrl+')'"></van-button>
        <img wx:else :src="formData.assistCouponActivityStyle.assistPersonStyle.assistBtnImageUrl" />
      </div>
    </div>
  </div>
</div>

</template>
<script>
import utils from '@/utils/common'
import { navigateTo } from '@/views/activities/utils'
export default {
  data(){
    return{
      images:[{},{},{},{},{}],
      formData:{},
      shearId:'',
      showStatus:false,
      addIcon:require('../../../../assets/icon_add.png')
    }
  },
  props:{

    floor: Object,
    home: Object,
    floor:{
      default:()=>{
        return {}
      },
      type:Object
    },
    
    // activityId:{
    //   default:'',
    //   type:[String,Number]
    // }
  },
  watch:{
    floor:{
      handler:function(){
        this.getDetails()
      },
      deep:true
    }
  },
  created(){
    this.getDetails();
    console.log('home',this.home)
  },
  methods:{
    getDetails(){
      let images;
      let assistUserInfo = this.floor.assistCouponActivitySharedInfo.assistUserInfo ||null;
      let taskCount = this.floor.assistCouponActivitySharedInfo.taskCount ||5;
      let userLength =assistUserInfo?assistUserInfo.length :0
      if(taskCount == userLength){
        images = assistUserInfo;
      }else{
        images = assistUserInfo ? assistUserInfo:[];
        for(let i=0;i<taskCount-userLength;i++){
          images.push({})
        }
      }
      this.formData = this.floor.assistCouponActivitySharedInfo;
      this.images=images,
      this.shearId=this.floor.assistCouponActivitySharedInfo.shareId
      this.checkAcitvityToast();
    },
    checkAcitvityToast(){
      let that = this;
      let activityStauts = that.formData.activityStatus;
      let restCount = that.formData.restCount;
      let info='';
      // 0=未开始，1=进行中，2=已结束，3已关闭
      switch (activityStauts) {
        case 0:
          break;
        case 1:
          if(that.formData.joinStatus ==1){
            that.showStatus =true;
            return ;
          }
          break;
        case 2:
          
          break;
        case 3:
          
          break;
        default:
          break;
      }
      if(that.formData.pageNotice){
        this.$toast(that.formData.pageNotice)
        return ;
      }
    },
    // 关闭弹窗
    showModalFun(){
      this.showStatus=!this.showStatus;
    },
    // 弹窗
    involvementActicity(type){
      if(type ==1 && this.formData.joinStatus==1){
        this.showModalFun();
      }else if(type==2 && this.formData.joinStatus==1){
        this.createShearFun();
      }
    },
    // 创建分享
    createShearFun(){
      this.http({
        method:'post',
        url:'/order/app/coupon-assist-activity/share',
        parmes:{
          activityPageId:this.home.$options.activityId,
          couponActivityId:this.floor.couponActivityId
        }
      }).then(res=>{
        if(res.code ==200){
          this.showStatus=false;
          this.shareId=res.data.shareId
          // this.$emit('callSomeFun',res.data.shareId)
          this.$emit('call',{fn:'reloadData',data:{ shareId: res.data.shareId }})
        }
      })

    },
    //跳转
    jumpToAddress(type,value){
      let that = this;
      let jumpType,jumpValue,miniUrl,action;
      let obj = {}
      if(type == "sharePersonStyle"){
        jumpType = that.formData.assistCouponActivityStyle.sharePersonStyle.afterReceiveBtnLinkType;
        jumpValue = that.formData.assistCouponActivityStyle.sharePersonStyle.afterReceiveBtnLinkValue;
      }else{
        jumpType = that.formData.assistCouponActivityStyle.assistPersonStyle.afterAssistJumpLinkType;
        jumpValue = that.formData.assistCouponActivityStyle.assistPersonStyle.afterAssistJumpLinkValue;
      }
      jumpType = ({1:1, 2:3, 3:4, 4:2, 5:12, 6:13, 7:11 })[jumpType];
      navigateTo(this, { pageLinkType:jumpType,pageLinkValue:jumpValue})

      // switch (jumpType) {
      //   case 2:
      //     obj = {goodsId:parseInt(jumpValue)};
      //     miniUrl = `${window.location.origin}/commoditydetails?id=${jumpValue}`
      //     action={tm:"4030100",tp:obj};
      //     break;
      //   case 3:
      //     miniUrl =`${window.location.origin}/brandindex?id=${jumpValue}`;
      //     action='{tm:"4090100",tp:"{branchId:'+jumpValue+'}"';
      //     break;
      //   case 4:
      //     miniUrl = jumpValue
      //     break;
      //   case 6:
      //     miniUrl = `${window.location.origin}/myCoupon`;
      //     break;
      //   case 5:
      //     utils.goPageByName({ id: "index", name: "首页" });
      //     break;
      //   default:
      //     break;
      // }
      // if(jumpType !=5 &&miniUrl ){
      //   utils.jumpToNewPage({url: miniUrl, noTitle: '0',action})
      // }
      
    },
    // 领取优惠劵
    receiveCoupons(type){
      this.http({
        url:'/order/app/coupon-assist-activity/receive',
        method:'post',
        parmes:{
          activityPageId:this.home.$options.activityId,
          couponActivityId:this.floor.couponActivityId
        }
      }).then(rps=>{
        if(rps.code ==200){
          this.$toast('领取成功！')
          this.$emit('call',{fn:'reloadData'})
        }
      })
    },
    // 助力？
    helpPersonFun(){
      this.http({
        url:'/order/app/coupon-assist-activity/assist',
        method:'post',
        parmes:{
          shareId:this.shearId,
          avatarUrl:''
        }
      }).then(rps=>{
        if(rps.code ==200){
          this.$toast('助力成功');
          this.$emit('call',{fn:'reloadData'})
        }
      })
    },
    getshareInfo(){
      let actCode = {actCode: this.$route.query.actCode,assistCouponActivityShareId:this.shearId}     
      let params = {
          tm: '4110101',
          tp: {
              actCode: JSON.stringify(actCode),
              activityId: this.home.$options.activityId,
          }
      }
      console.log(params);
      utils.nativeMethod(params); 
    },
    styleObject(bg){
      let obj={
        backgroundSize:'100% 100%'
      }
      if(bg){
        obj.backgroundImage=`url(${bg})`;
      }
      return obj
    }
  }
};
</script>
<style lang="less" scoped>
/* activityIndex/subcoment/shareCouponsItem/index.wxss */
.share_index_warp{
  background-color: #f7f7f7;
}

.share_index_warp .share_index_image{
  background: #fff;
  margin-top: 10px;
  text-align: center;
}
.share_index_warp .share_index_button{
  background: #fff;
}
.share_index_warp .share_index_button button{
  width: 100%;
  height: 100px;
  background: linear-gradient(90deg, #FF8200 0%, #FF1414 100%);
  border-radius: 32px;
  font-size: 24px;
  color: #fff;
  object-fit: cover;
  border: 0 !important;
}
.share_index_warp .share_index_text{
  font-size: 28px;
  padding: 24px 30px;
  font-weight: bold;
  background: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.share_index_warp .share_index_text img{
  width: 70px;
  height: 70px;
  margin-right: 20px;
  border-radius: 50%;
}
.share_index_warp .share_index_info{
  font-size: 24px;
  font-weight: bold;
  padding: 20px 40px;
  background: #fff;
  margin-top: 10px;
}
.share_index_warp .share_index_info text ,.share_index_warp .share_index_text span{
  color: #ED3939;
}
.share_index_warp .share_index_content{
  display: flex;
  justify-content: flex-start;
  align-content: center;
  flex-wrap: wrap;
  padding: 20px 40px;
  background: #fff;
}
.share_index_warp .share_index_content .share_index_content_image{
  width: 20%;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  
}

.share_index_warp .share_index_content .share_index_content_image img{
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: block;
}

.share_index_warp .share_index_content .share_index_content_image span{
  font-size: 24px;
  color: #333;
  width: 90px;
  padding-top: 9px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis; 
  white-space: nowrap; 

}
.share_index_warp .share_index_footer{
  margin-top: 40px;
  background: #fff;
}
.share_index_warp .share_index_footer .share_index_rule{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  color: #999;
  padding: 20px 0;
  background-color: #fff;
}
.share_index_warp .share_index_footer .share_index_rule span{
  color: #409EFF;
}
.share_index_warp .share_index_footer .share_index_rule img{
  width: 100%;
  height: 30px;
  margin-right: 10px;
}
.share_index_warp .share_index_footer .share_index_btn{
  background-color: #fff;
  // padding: 10px 0;
  text-align: center;
}
.share_index_warp .share_index_footer .share_index_btn button{
  background: #F8D541;
  width: 100%;
  border-radius: 40px;
  height: 100px;
  font-size: 24px;
  color: #333;
  padding: 0;
  border: 0;
}
.share_index_warp .share_index_footer .share_index_btn img{
  background: #F8D541;
  width: 100%;
  border-radius: 40px;
  font-size: 24px;
  color: #333;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100px;
}
.share_index_warp .share_coupon_flex{
  position: fixed;
  background: rgba(0,0,0,.8);
  z-index: 999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.share_index_warp .share_coupon_flex .image_flex{
  position: relative;
  text-align: center;
}
.share_index_warp .share_coupon_flex .image_flex .close{
  position: absolute;
  bottom: -20px;
  left: 45%;
  width: 80px;
  height: 80px;
  object-fit: cover;
}
</style>